import { GET_ENGAGEMENT_FAILURE, GET_ENGAGEMENT_REQUEST, GET_ENGAGEMENT_SUCCESS, UPDATE_ENGAGEMENT_DATA } from './types'
import axiosInstance from '../../utils/api'

export const fetchEngagementDataRequest = () => {
  return {
    type: GET_ENGAGEMENT_REQUEST,
  }
}
export const fetchEngagementDataSuccess = (value) => {
  return {
    type: GET_ENGAGEMENT_SUCCESS,
    payload: value,
  }
}
export const fetchEngagementDataFailure = (error) => {
  return {
    type: GET_ENGAGEMENT_FAILURE,
    payload: error,
  }
}
export const fetchEngagementUpdateSuccess = (error) => {
  return {
    type: UPDATE_ENGAGEMENT_DATA,
    payload: error,
  }
}

export const getEngagementMpData = (id, page) => async (dispatch) => {
  dispatch(fetchEngagementDataRequest())
  await axiosInstance
    .get(`/api//user/getmplbdata/${id}?page=${page}`)
    .then((response) => {
      const result = response.data?.result
      page == 1 ? dispatch(fetchEngagementDataSuccess(result)) : dispatch(fetchEngagementUpdateSuccess(result))
    })
    .catch((error) => {
      const errorMsg = error.message
      dispatch(fetchEngagementDataFailure(errorMsg))
    })
}
